// extracted by mini-css-extract-plugin
module.exports = {"inner":"inner-2Sq1U","opened":"opened-27tsh","searchForm":"searchForm-1hT_m","form":"form-3ArrZ","wrapper":"wrapper-BsO6Z","outer__summary":"outer__summary-1Il5V"};